module.exports = __webpack_public_path__ + "media/images/registration-icon-34c017592430e78a42d30b74368115dc.svg";